import { DEFAULT, DARK, SHADE } from './useOptions';
export const getColorNames = ({
  use
}) => {
  switch (use) {
    case SHADE:
      return {
        primary: 'fill-tertiary-default',
        secondary: 'fill-surface-raised'
      };
    case DARK:
      return {
        primary: 'fill-accent-neutral-default',
        secondary: 'fill-accent-neutral-hover'
      };
    case DEFAULT:
    default:
      return {
        primary: 'fill-surface-raised',
        secondary: 'fill-tertiary-default'
      };
  }
};
export const getColors = ({
  use,
  theme
}) => {
  const {
    primary,
    secondary
  } = getColorNames({
    use
  });
  return {
    primary: theme.color[primary],
    secondary: theme.color[secondary]
  };
};
export const makeBlankBackground = ({
  theme
}) => ({
  background: theme.color['fill-surface-default']
});
export const makeGradientBackgroundCss = ({
  primary,
  secondary
}) => `
  background: ${primary};
  background: linear-gradient(to right, ${primary}, ${secondary} 20%, ${primary} 40%);
`;